import React, { ReactElement, useEffect, useState } from 'react';
import { LoginPage } from 'pages/LoginPage';
import { TwoFactorAuthPage } from 'pages/TwoFactorAuthPage';
import { LazyDashboardPage as DashboardPage } from 'pages/DashboardPage/LazyDashboardPage';
import { FC_SYSTEM_AUTH_ACCESS_TOKEN } from 'requests/auth';
import { useLocation, useNavigate } from 'react-router-dom';
import { ERouteLinks } from 'models/route';
import { AuthenticatorPage } from 'pages/AuthenticatorPage';

export interface IData {
  email: string;
  password: string;
  phoneNumber: string;
  offlineQRCodeBase64: string | null;
}

export enum EStep {
  login = 'login',
  twoFactorAuth = 'twoFactorAuth',
  authenticator = 'authenticator',
  dashboard = 'dashboard',
}

const AuthPage = (): ReactElement => {
  const [isLoading, setLoading] = useState(true);
  const [formStep, setFormStep] = useState(EStep.login);
  const [data, setData] = useState<IData>({
    email: '',
    password: '',
    phoneNumber: '',
    offlineQRCodeBase64: null,
  });
  const navigate = useNavigate();
  const { state: routerState }: any = useLocation();

  useEffect(() => {
    if (localStorage.getItem(FC_SYSTEM_AUTH_ACCESS_TOKEN)) {
      navigate(ERouteLinks.Dashboard);
    }
  }, [navigate]);

  useEffect(() => {
    if (localStorage.getItem(FC_SYSTEM_AUTH_ACCESS_TOKEN) !== null) {
      setFormStep(EStep.dashboard);
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    if (routerState?.twoFactorMethod) {
      setData((prevState: IData) => ({
        ...prevState,
        email: routerState?.email,
        password: routerState?.password,
        offlineQRCodeBase64: routerState?.offlineQRCodeBase64,
      }));
      setFormStep(routerState?.twoFactorMethod as EStep);
    }
  }, []);

  useEffect(() => () => window.history.replaceState({}, document.title), []);

  const renderAuthPage = () => {
    switch (formStep) {
      case EStep.login:
        return (
          <LoginPage
            changePage={(step: EStep) => setFormStep(step)}
            changeDataCallback={(d) => setData(d)}
          />
        );
      case EStep.twoFactorAuth:
        return (
          <TwoFactorAuthPage
            email={data.email}
            password={data.password}
            phoneNumber={data.phoneNumber}
            changeDataCallback={(d) => setData(d)}
          />
        );
      case EStep.authenticator:
        return (
          <AuthenticatorPage
            offlineQRCodeBase64={data.offlineQRCodeBase64}
            email={data.email}
          />
        );
      case EStep.dashboard:
        return <DashboardPage />;
      default:
        return <div />;
    }
  };

  return <div>{!isLoading && renderAuthPage()}</div>;
};
export { AuthPage };
